/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Sso_ErrorInputs */

const en_signin_sso_error = /** @type {(inputs: Signin_Sso_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not reach the sign-in service. Try again in a moment.`)
};

/** @type {(inputs: Signin_Sso_ErrorInputs) => LocalizedString} */
const ar_signin_sso_error = en_signin_sso_error;

/** @type {(inputs: Signin_Sso_ErrorInputs) => LocalizedString} */
const he_signin_sso_error = en_signin_sso_error;

/** @type {(inputs: Signin_Sso_ErrorInputs) => LocalizedString} */
const ur_signin_sso_error = en_signin_sso_error;

/** @type {(inputs: Signin_Sso_ErrorInputs) => LocalizedString} */
const es_signin_sso_error = en_signin_sso_error;

/** @type {(inputs: Signin_Sso_ErrorInputs) => LocalizedString} */
const fr_signin_sso_error = en_signin_sso_error;

/** @type {(inputs: Signin_Sso_ErrorInputs) => LocalizedString} */
const de_signin_sso_error = en_signin_sso_error;

/** @type {(inputs: Signin_Sso_ErrorInputs) => LocalizedString} */
const pt_signin_sso_error = en_signin_sso_error;

/** @type {(inputs: Signin_Sso_ErrorInputs) => LocalizedString} */
const hi_signin_sso_error = en_signin_sso_error;

/** @type {(inputs: Signin_Sso_ErrorInputs) => LocalizedString} */
const bn_signin_sso_error = en_signin_sso_error;

/**
* | output |
* | --- |
* | "We could not reach the sign-in service. Try again in a moment." |
*
* @param {Signin_Sso_ErrorInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_sso_error = /** @type {((inputs?: Signin_Sso_ErrorInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Sso_ErrorInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_sso_error(inputs)
	if (locale === "he") return he_signin_sso_error(inputs)
	if (locale === "ur") return ur_signin_sso_error(inputs)
	if (locale === "es") return es_signin_sso_error(inputs)
	if (locale === "fr") return fr_signin_sso_error(inputs)
	if (locale === "de") return de_signin_sso_error(inputs)
	if (locale === "pt") return pt_signin_sso_error(inputs)
	if (locale === "hi") return hi_signin_sso_error(inputs)
	if (locale === "bn") return bn_signin_sso_error(inputs)
	return /** @type {LocalizedString} */ ("We could not reach the sign-in service. Try again in a moment.")
});